import { render, staticRenderFns } from "./popue.vue?vue&type=template&id=355efb21&scoped=true"
import script from "./popue.vue?vue&type=script&lang=js"
export * from "./popue.vue?vue&type=script&lang=js"
import style0 from "./popue.vue?vue&type=style&index=0&id=355efb21&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355efb21",
  null
  
)

export default component.exports